module.exports = __webpack_public_path__ + "static/media/Finnovex-East-Africa-2023.0c2b5d79.png";